import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface GetAlarmProfilesResult {
  success: boolean;
  body?: any;
  error?: string;
  status?: number;
}

export const getAlarmProfilesUseCase = async (
  signal?: AbortSignal,
): Promise<GetAlarmProfilesResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;

    const sourceId = store.getState().yourSlice.connectionView.source.source_id;

    const response = await apiUseCases.getAlarmProfilesAPI(
      namespace,
      sourceId,
      signal,
    );

    return {
      status: response?.status,
      success: true,
      body: response?.data,
    };
  } catch (error) {
    const { message, status } = parseAxiosApiError(
      error,
      "Failed to fetch alarm profiles",
    );
    return {
      success: false,
      error: message,
      status,
    };
  }
};
